import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const tasks = [
  {
    path: '/vector/tasks/:task_uuid',
    name: 'vector-task-detail',
    component: () => import('@/pages/vector/tasks/TaskDetailPage.vue'),
    meta: {
      title: 'Task Details',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/tasks/queue',
    name: 'vector-task-queue',
    component: () => import('@/pages/vector/tasks/queue.vue'),
    meta: {
      title: 'Task Queue',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default tasks
